export const ActionTypes = {
  SET_ACTIVE_PAGE: "SET_ACTIVE_PAGE",
  SET_ACTIVE_LANGUAGE: "SET_ACTIVE_LANGUAGE",
  SET_USER_CREDENTIALS: "SET_USER_CREDENTIALS",
  SET_SIDE_PANEL_STATUS: "SET_SIDE_PANEL_STATUS",
  SET_SIDE_PANEL_STATUS_AND_TYPE: "SET_SIDE_PANEL_STATUS_AND_TYPE",
  SET_SIDE_PANEL_RESULT_TYPE: "SET_SIDE_PANEL_RESULT_TYPE",
  SET_ALERT: "SET_ALERT",
};
